const ZeroTrust = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="69.1514"
      height="69.1514"
      rx="1"
      fill="url(#paint0_linear_9113_7281)"
    />
    <path
      d="M32.4148 35.2132L29.6163 32.4147L28.0928 33.9382L32.4148 38.2602L41.0587 29.6163L39.5352 28.0928L32.4148 35.2132Z"
      fill="#010812"
    />
    <path
      d="M34.5758 49.7026L27.9029 46.1447C26.0004 45.1326 24.4095 43.6216 23.3008 41.7738C22.1921 39.926 21.6076 37.8111 21.6099 35.6562V21.6098C21.6105 21.0369 21.8383 20.4876 22.2435 20.0825C22.6486 19.6773 23.1979 19.4495 23.7709 19.4489H45.3807C45.9536 19.4495 46.5029 19.6773 46.9081 20.0825C47.3132 20.4876 47.5411 21.0369 47.5417 21.6098V35.6562C47.544 37.8111 46.9594 39.926 45.8507 41.7738C44.7421 43.6216 43.1511 45.1326 41.2487 46.1447L34.5758 49.7026ZM23.7709 21.6098V35.6562C23.769 37.4194 24.2473 39.1498 25.1545 40.6616C26.0616 42.1735 27.3634 43.4098 28.92 44.2378L34.5758 47.2535L40.2315 44.2378C41.7881 43.4098 43.0899 42.1735 43.9971 40.6616C44.9042 39.1498 45.3825 37.4194 45.3807 35.6562V21.6098H23.7709Z"
      fill="#010812"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9113_7281"
        x1="34.5757"
        y1="0"
        x2="34.5757"
        y2="69.1514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8E8FA" />
        <stop offset="1" stopColor="#485CC7" />
      </linearGradient>
    </defs>
  </svg>
);

export default ZeroTrust;
